import { Input } from "antd";

export const EditCharacteristicOpenEnded = () => <Input.TextArea disabled />;
